import { createSlice } from "@reduxjs/toolkit";
import FILTERS_KEYS from "@utils/filters_keys.js";
import { REHYDRATE } from "redux-persist/es/constants";
import { mergeFilters, toggleReduxSliceFiltersVisibility } from "../../../helpers/reduxHelpers.js";

const defaultFilters = [
	{ id: FILTERS_KEYS.clients.businessUnits, name: "clients:businessUnitFilter", visible: false },
	{ id: FILTERS_KEYS.clients.distributors, name: "clients:distributorFilter", visible: false },
];

const initialState = {
	data: [],
	list: [],
	filters: [...defaultFilters],
	selectedClient: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	clientsFetched: false,
	users: {
		loading: false,
		data: null,
		pagination: {
			page: 1,
			perPage: 10,
			totalItems: 0,
			totalPage: 0,
		},
	},
};

const clientsSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setClientsData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},
		setLoadingClients: (state, action) => {
			state.loading = action.payload;
		},
		setSelectedClient: (state, action) => {
			state.selectedClient = action.payload;
		},
		setAddClient: (state, action) => {
			state.data.push(action.payload);
			state.totalItems += 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setEditClient: (state, action) => {
			const { id, updatedData } = action.payload;
			state.data = state.data.map((unit) => (unit.id === id ? { ...unit, ...updatedData } : unit));
		},
		setDeleteClient: (state, action) => {
			state.data = state.data.filter((unit) => unit.id !== action.payload);
		},
		setAllClientsList: (state, action) => {
			const { data } = action.payload;
			state.list = data || [];
		},

		setAllClientsListMore: (state, action) => {
			const data = action.payload;
			state.list = data || [];
		},
		clearClients: (state) => {
			return initialState;
		},
		toggleClientsFiltersVisibility: toggleReduxSliceFiltersVisibility,
		setClientUsers: (state, action) => {
			const { data = [], page = 1, perPage = 10, totalItems = 0 } = action.payload || {};

			state.users.loading = false;
			state.users.data = data;
			state.users.pagination = {
				page,
				perPage,
				totalItems,
				totalPage: Math.ceil(totalItems / perPage),
			};
		},

		setLoadingClientUsers: (state, action) => {
			state.users.loading = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(REHYDRATE, (state, action) => {
			// Get persisted filters
			const persistedFilters = action.payload?.modules?.accountManagement.clients?.filters ?? null;
			// Merge filters with persisted state
			state.filters = mergeFilters(persistedFilters, defaultFilters);
		});
	},
});

export const {
	setClientsData,
	setLoadingClients,
	setSelectedClient,
	setAddClient,
	setEditClient,
	setDeleteClient,
	setAllClientsList,
	setAllClientsListMore,
	clearClients,
	toggleClientsFiltersVisibility,
	setClientUsers,
	setLoadingClientUsers,
} = clientsSlice.actions;
export default clientsSlice.reducer;
